export default __webpack_public_path__ + "static/media/dr-avatar-2.04e258df.png";